'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' });

var Crop75 = function Crop75(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Crop75 = (0, _pure2.default)(Crop75);
Crop75.muiName = 'SvgIcon';

exports.default = Crop75;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Crop75.js
// module id = 2290
// module chunks = 0